import { render, staticRenderFns } from "./NotificationComponent.vue?vue&type=template&id=77f54a8d&scoped=true"
import script from "./NotificationComponent.vue?vue&type=script&lang=js"
export * from "./NotificationComponent.vue?vue&type=script&lang=js"
import style0 from "./NotificationComponent.vue?vue&type=style&index=0&id=77f54a8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f54a8d",
  null
  
)

export default component.exports